export var AssetStatisticsTypeEnum;
(function (AssetStatisticsTypeEnum) {
    AssetStatisticsTypeEnum["EXCHANGE"] = "EXCHANGE";
    AssetStatisticsTypeEnum["DEPOSIT"] = "DEPOSIT";
    AssetStatisticsTypeEnum["WITHDRAW"] = "WITHDRAW";
})(AssetStatisticsTypeEnum || (AssetStatisticsTypeEnum = {}));
//# sourceMappingURL=asset-statistics-type.enum.js.map